module.exports = __webpack_public_path__ + "static/app-hero-386ed7e34bce2b877acea3c9d75d8580.png";